'use client'
import {
  SkeletonCircle
} from "./chunk-W7A7QDAK.mjs";
import {
  SkeletonText
} from "./chunk-IYS4KVU2.mjs";
import {
  Skeleton
} from "./chunk-GOJLRND4.mjs";
import "./chunk-AASO4CLC.mjs";
export {
  Skeleton,
  SkeletonCircle,
  SkeletonText
};
//# sourceMappingURL=index.mjs.map